import { render, staticRenderFns } from "./AddUserGroup.vue?vue&type=template&id=0fe3abb1&scoped=true"
import script from "./AddUserGroup.vue?vue&type=script&lang=js"
export * from "./AddUserGroup.vue?vue&type=script&lang=js"
import style0 from "./AddUserGroup.vue?vue&type=style&index=0&id=0fe3abb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe3abb1",
  null
  
)

export default component.exports